export const initValuePrefix = "init_";

export function setLayerProperty(layer, propertyName, value, setInitValue = true) {
  const initialPropertyName = initValuePrefix + propertyName;

  if (setInitValue && layer[initialPropertyName] === undefined) {
    layer[initialPropertyName] = layer[propertyName];
  }

  layer[propertyName] = value;

  const keys = Object.keys(layer).filter(x => !x.startsWith(initValuePrefix));

  layer.modified = keys.some(key => {
    const initialKey = initValuePrefix + key;
    return (layer[initialKey] !== undefined && layer[initialKey] !== layer[key]);
  });
}

export function getBasicGeometryType(type) {
  type = type ? type.toLowerCase() : type;
  switch(type) {
    case "multipoint":
      return "point";
    case "multilinestring":
    case "circularstring":
    case "compoundcurve":
    case "multicurve":
      return "linestring";
    case "multipolygon":
    case "curvepolygon":
    case "multisurface":
      return "polygon";
    default:
      return type;
  }
}
